import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Products = () => {
    const products = [
        { id: 1, image: 'scented_ethos/coffee.png', description: 'Awaken your senses with the rich, invigorating aroma of freshly brewed coffee, perfect for energizing your day.', theme: 'rgba(214, 150, 104, 0.8)' }, // Faint Brownish
        { id: 2, image: 'scented_ethos/jasmine.png', description: 'Immerse yourself in the delicate, floral elegance of jasmine, a timeless scent that soothes and uplifts.', theme: 'rgba(203, 247, 221, 0.77)' }, // Faint Greenish
        { id: 3, image: 'scented_ethos/lavendar.png', description: 'Relax and unwind with the calming essence of lavender, a gentle embrace for your mind and soul.', theme: 'rgba(246, 206, 246, 0.8)' }, // Faint Purpleish
        { id: 4, image: 'scented_ethos/Rose.png', description: 'Experience the romantic allure of roses, a classic fragrance that exudes beauty and sophistication.', theme: 'rgba(249, 187, 244, 0.8)' }, // Faint Pinkish
        { id: 5, image: 'scented_ethos/sandalwood.png', description: 'Indulge in the warm, woody richness of sandalwood, a grounding scent that inspires tranquility and balance.', theme: 'rgba(246, 226, 188, 0.8)' }, // Faint Yellowish
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
        }, 3000); // Change image every 3 seconds
        return () => clearInterval(interval);
    }, [products.length]);

    const currentTheme = products[currentIndex].theme;

    return (
        <div
            style={{
                position: 'relative',
                height: '100vh',
                overflow: 'hidden',
                background: currentTheme,
                transition: 'background 1s ease',
                margin: 0, // Ensure no margin
                padding: 0, // Ensure no padding
            }}
        >
            {/* Header */}
            <div style={{
                position: 'absolute',
                top: '20px',
                right: '50%',
                transform: 'translateX(50%)',
                fontFamily: 'Georgia, serif',
                fontSize: '36px',
                fontWeight: 'bold',
                color: '#5a3e2b',
                zIndex: 10,
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
                letterSpacing: '2px',
            }}>
                ✨ Our Exquisite Collection ✨
            </div>

            {/* Main Content */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <motion.div
                    key={products[currentIndex].id}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 1 }}
                    style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                        borderRadius: '15px',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={products[currentIndex].image}
                        alt={`Product ${products[currentIndex].id}`}
                        style={{
                            width: '350px',
                            height: '400px',
                            objectFit: 'cover',
                            borderRadius: '15px',
                            border: '5px solid rgba(79, 70, 70, 0.6)', // Darker outline but not pure black
                        }}
                    />
                </motion.div>
                <motion.div
                    key={`desc-${products[currentIndex].id}`}
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -50 }}
                    transition={{ duration: 1 }}
                    style={{
                        flex: 1,
                        padding: '30px',
                        background: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '15px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                        marginLeft: '20px',
                    }}
                >
                    <h2 style={{
                        fontFamily: 'cursive',
                        fontSize: '24px',
                        lineHeight: '1.8',
                        color: '#5a3e2b',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                    }}>
                        {products[currentIndex].description}
                    </h2>
                </motion.div>
            </div>
        </div>
    );
};

export default Products;